import { computed, toValue, type MaybeRefOrGetter } from 'vue';
import type { Price, PricingGroup } from '@cvo/domain';

export type PricingGroupKey = 'fees' | 'taxes';

export interface PricingGroupLine {
  id: string;
  label: string;
  price: Price;
}

export function usePricingGroupLines(group: MaybeRefOrGetter<PricingGroup | undefined>, groupKey: PricingGroupKey) {
  const { t, tf } = useI18n();
  const { features } = useAppConfig();

  /** The group total, or one line per charge code when detailed. */
  const lines = computed<PricingGroupLine[]>(() => {
    const groupValue = toValue(group);
    if (!groupValue) return [];

    const groupLabel = t(`ui.components.priceBreakdown.${groupKey}`);

    if (!features.detailedPriceBreakdown || !groupValue.items.length) {
      return [{ id: groupKey, label: groupLabel, price: groupValue.total }];
    }

    return groupValue.items.map(item => ({
      id: `${groupKey}-${item.type}`,
      label: item.type === 'OTHER' ? groupLabel : tf(`custom.priceBreakdown.${item.type}`, item.type),
      price: item.price,
    }));
  });

  return { lines };
}
